import React from 'react';
import Navbar from '../../../components/navbar/ui/Navbar';
import Footer from '../../../components/footer/ui/Footer';
import ScrollToTop from '../../../components/scroll-to-top/ui/ScrollToTop';
import SEO from '../../../components/seo/SEO';
import '../style/not-found.css';

const NotFoundPage: React.FC = () => {
    return (
        <>
            <SEO
                title="Página não encontrada - Roady Centro-Auto Chaves"
                description="A página que procura não existe ou foi movida. Utilize o menu para continuar a navegar no site Roady Centro-Auto Chaves."
                noindex={true}
            />
            <div className="not-found-page">
                <Navbar />
                <section className="page-header not-found-header">
                    <div className="page-header__bg" />
                    <div className="container">
                        <div className="page-header__inner">
                            <h1>404 - Página não encontrada</h1>
                        </div>
                    </div>
                </section>

                <section className="not-found-content">
                    <div className="container">
                        <div className="not-found-card">
                            <div className="not-found-animation">
                                <div className="not-found-road" />
                                <div className="not-found-car">
                                    <div className="not-found-car-body">
                                        <div className="not-found-car-window" />
                                        <div className="not-found-car-line" />
                                    </div>
                                    <div className="not-found-car-wheel not-found-car-wheel--left" />
                                    <div className="not-found-car-wheel not-found-car-wheel--right" />
                                </div>
                            </div>
                            <div className="not-found-code">404</div>
                            <h2 className="not-found-title">Ups! Esta página não existe.</h2>
                            <p className="not-found-text">
                                O endereço que introduziu pode estar errado ou a página pode ter sido removida.
                            </p>
                            <a href="/" className="thm-btn not-found-btn">
                                Voltar à página inicial
                            </a>
                        </div>
                    </div>
                </section>

                <Footer />
                <ScrollToTop />
            </div>
        </>
    );
};

export default NotFoundPage;


